// Route guard — requires a token, plus optionally a permission key.
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

export default function PrivateRoute({ children, permission = null, anyOf = null }) {
  const token = localStorage.getItem("token");
  const { user, hasPermission, hasAny, loading } = useAuth();

  if (!token) return <Navigate to="/sign-in" replace />;

  // Still loading the session the first time — don't decide yet.
  if (loading && !user) {
    return (
      <div style={{ padding: 48, textAlign: "center", color: "#64748b" }}>
        Loading...
      </div>
    );
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/access-denied" replace />;
  }
  if (anyOf && !hasAny(anyOf)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
}
